import angular from 'angular';

const controllerInfo = {
    module: 'ib-bob-module',
    inject: ['object'],
    required: []
};

export class BobController implements ng.IController {
    public model;

    constructor (private object: any) {
        this.model = object;
    }
}

try {
    BobController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(BobController.name, BobController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    BobController.$inject = controllerInfo.inject;
    mod.controller(BobController.name, BobController);
}